<template>
    <div class="media-bank">
        <div class="media-bank__filter media-bank-filter">
            <z-tabs v-if="filters.type.length" only-visual @toggle-item="onTabChange($event)">
                <template v-slot:label>
                    <z-tabs-label
                        v-for="type in filters.type"
                        :key="type.id"
                        :id="type.id"
                        :initial-state="type.selected"
                    >{{localeText[type.xmlId]}}</z-tabs-label>
                </template>
            </z-tabs>
            <z-select
                @change="onSelectChange($event)"
                class="media-bank-filter__select"
                :data="subjectsOptions"
                :placeholder="subjectsPlaceholder"
                :value="currentSubjectId"
            ></z-select>
        </div>

        <div class="media-bank__count">{{localeText.total}}: {{nav.count}}</div>

        <div class="media-bank__content">
            <div v-if="list && list.length" class="row">
                <div
                    v-for="(card, i) of list"
                    :key="card.code"
                    class="col-default-4 col-v-tablet-6 col-mobile-12"
                >
                    <media-bank-card
                        :data="card"
                        @openModal="$root.$bus.$emit('open-modal', {id: 'media-modal', index: i})"
                    />
                </div>
            </div>
            <z-not-found v-else />
            <div class="media-bank__preloader" v-if="loading">
                <z-preloader />
            </div>
        </div>

        <div class="media-bank__pagination">
            <z-pagination
                show-next
                show-prev
                :data="paginationData"
                @change="onPageChange"
            />
        </div>

        <z-modal
            class="media-bank__modal"
            id="media-modal"
            pagination
            :data="slidesForModal"
        >
        </z-modal>
    </div>
</template>

<script>
import MediaBankCard from './components/MediaBankCard.vue'
import { getMedia } from '@/api/media'
import { debounce } from 'throttle-debounce'
import { queryString } from '@/utils/queryString'
import { localize } from '@/utils/i18n'

export default {
    name: 'media-bank',
    components: {
        MediaBankCard
    },
    props: {
        initial: {
            type: Object
        }
    },
    data () {
        return {
            loading: false,
            params: {
                subjects: [],
                kind: '',
                page: 1
            },
            notFound: {
                state: false,
                text: localize({
                    'ru': 'По&nbsp;Вашему запросу ничего не&nbsp;нашлось.',
                    'en': 'Sorry, no matches were found for your request. Try changing your search terms.'
                })
            },
            localeText: {
                photo: localize({
                    'ru': 'Фото',
                    'en': 'Photo'
                }),
                video: localize({
                    'ru': 'Видео',
                    'en': 'Video'
                }),
                total: localize({
                    'ru': 'Всего',
                    'en': 'Total'
                })
            },
            subjectsPlaceholder: localize({
                'ru': 'Тема',
                'en': 'Theme'
            }),
            subjectsOptions: [
                {
                    'id': 'all',
                    'selected': false,
                    'disabled': false,
                    'text': localize({
                        'ru': 'Все темы',
                        'en': 'All themes'
                    }),
                    'xmlId': 'all'
                }
            ],
            filters: this.$root.app.components['media-bank'].filters,
            list: this.$root.app.components['media-bank'].items,
            nav: this.$root.app.components['media-bank'].nav
        }
    },
    computed: {
        slidesForModal () {
            let result = this.list.map((el) => {
                if (el.type.xmlId === 'photo') {
                    return ({
                        'type': 'image',
                        'detail': el.detailText,
                        'image': {
                            'preview': el.previewPicture.link,
                            'full': el.photo.link || el.previewPicture.link
                        }
                    })
                } else if (el.type.xmlId === 'video') {
                    return ({
                        'type': 'video',
                        'detail': el.detailText,
                        'image': {
                            'preview': el.previewPicture.link,
                            'full': el.video.value
                        }
                    })
                }
            })
            return result
        },
        paginationData () {
            return {
                currentPage: this.nav?.current,
                totalItems: this.nav?.count,
                totalPages: this.nav?.total,
                pageRange: 1
            }
        },
        currentSubjectId () {
            return this.filters.subjects.find(el => el.selected)?.id || ''
        }
    },
    methods: {
        clickSiblingsModal (obj) {
            if (obj.dir === 'prev' && obj.index > 0) {
                this.openModal(this.list[obj.index - 1], obj.index - 1)
            }

            if (obj.dir === 'next' && obj.index < this.list.length - 1) {
                this.openModal(this.list[obj.index + 1], obj.index + 1)
            }
        },
        onSelectChange (id) {
            if (id === 'all') {
                this.params.subjects = ''
            } else {
                this.params.subjects = id
            }
            this.params.page = 1
            this.send(this)
        },
        preparePrams () {
            const { kind, ...params } = this.params
            params.type = kind
            return params
        },
        onTabChange (tab) {
            const type = tab.replace('tabs-', '')
            this.filters.type.forEach(obj => {
                if (obj.id === type) {
                    obj.selected = true
                } else {
                    obj.selected = false
                }
            })

            this.params.kind = type
            this.params.page = 1
            this.send(this)
        },
        onPageChange (page) {
            this.params.page = page
            this.loading = true
            this.send(this)
        },
        send: debounce(500, _this => {
            queryString(_this.clearEmptyParams())
            _this.loading = true
            getMedia(_this.preparePrams())
                .then((res) => {
                    if (res.hasOwnProperty('nav')) {
                        _this.nav = res.nav
                    }

                    if (res.hasOwnProperty('items')) {
                        _this.list = res.items
                    }

                    _this.loading = false
                })
        }),
        clearEmptyParams () {
            const params = {...this.params}
            Object.keys(params).forEach(function (key, index) {
                if (Array.isArray(params[key])) {
                    if (!params[key].length) delete params[key]
                } else if (!params[key]) {
                    delete params[key]
                }
            })

            return params
        }
    },
    created () {
        this.params = {
            ...this.params,
            ...this.initial
        }

        if (this.filters.type.length && !this.filters.type.find(el => el.selected === true)) {
            this.filters.type[0].selected = true
        }

        this.params.kind = this.initial.type || this.filters.type.find(el => el.selected === true)?.id
        queryString(this.clearEmptyParams())

        if (this.filters.type.length > 0) {
            this.filters.type.sort((a, b) => a.xmlId.localeCompare(b.xmlId))
        }

        this.subjectsOptions = this.subjectsOptions.concat(this.filters.subjects)
    }
}
</script>

<style lang="scss">
.media-bank {
    &__filter {
        @include margin-level(bottom, XL);
        position: relative;
        z-index: 2;
    }

    &__count {
        @include margin-level(bottom, S);
    }

    &__modal {
        @include breakpoint (mobile) {
            .z-modal__container {
                padding-bottom: 0;
            }
        }
    }

    .media-bank-filter {
        display: flex;
        justify-content: space-between;
        align-items: center;

        @include breakpoint (mobile) {
            flex-direction: column;
            align-items: start;
        }

        &__select {
            width: 100%;
            max-width: 400px;
            @include margin-level(left, S);

            @include breakpoint (mobile) {
                margin-left: 0;
                @include margin-level(top, M);
            }
        }
    }

    &__pagination {
        display: flex;
        justify-content: center;
        @include margin-level(top, M);
    }

    &__content {
        position: relative;
        @include padding-level(bottom, S);

        .row > [class^="col-"] {
            margin-top: $token-spacers-m !important;

            @include breakpoint (laptop) {
                margin-top: $token-spacers-xs !important;
            }
        }
    }

    &__preloader {
        position: absolute;
        background: rgba($token-colors-white, 0.6);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 5;
    }
}
</style>
